import { isNotNullOrWhitespace as t } from "./string-utils.js";
function d(i, r, s) {
  r && t(r) ? i == null || i.setAttribute("data-testid", "".concat(r, "-").concat(s)) : i == null || i.removeAttribute("data-testid");
}
export { d as handleDataTestid };